import Vue from 'vue'

export default {
    UPDATE_PERSONS (state, value) {
        Vue.set(state, 'persons', value);
    },
  SET_PERSONS (state, value) {
        this.commit('UPDATE_PERSONS', value);
    },
    SET_SELECTED_PERSON (state,  value ) {
      Vue.set(state, 'selectedPerson', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/persons/mutations.js